import "./style.scss";

import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { ItemTaxonomyId } from "lib/taxonomy/item-taxonomy-id";
import React, { FunctionComponent } from "react";
import { useHistory } from "react-router-dom";

export interface CatalogItemProps {
  id?: string;
  name?: string;
  shortDescription?: string;
  logoUrl?: string;
  taxonomyId?: string;
  from?: string;
}

/**
 * Reusable component to render thumbnail of product and brief description
 */

export const CatalogItemCard: FunctionComponent<CatalogItemProps> = (props: CatalogItemProps) => {
  const history = useHistory();
  let detailsUrl = "#";

  // Since some catalog items will not have a strain value, parsing the taxonomy
  // could throw an error, handling this with a try/catch in the meantime
  try {
    detailsUrl = `/items/${ItemTaxonomyId.Parse(props.taxonomyId!).getUrlSuffix()}`;
    /* istanbul ignore next */
    if (props.from) {
      detailsUrl += `?from=${props.from}`;
    }
  } catch (error) {
    // TODO: report this error to cloudwatch. (To be resolved by ITMP-344)
    return <span>Incorrect item data.</span>;
  }

  /* istanbul ignore next */
  const onCatalogItemClick = (event: any) => {
    if (detailsUrl !== "#") {
      if (event.ctrlKey || event.metaKey) return true; // allows a new tab if ctrl + click and cmd + click

      history.push(detailsUrl);
      event.preventDefault();
    }
  };

  return (
    <a href={detailsUrl} style={{ textDecoration: "none" }}>
      <View
        key={`catalogItemCard-${props.id}`}
        onClick={onCatalogItemClick}
        display="flex"
        className="catalog-item-card"
        style={{ cursor: "pointer" }}
      >
        <Row gridGap={"S300"}>
          {/* Logo image  */}
          <View
            display="flex"
            height="74px"
            width="74px"
            padding="12px"
            alignItems="center"
            justifyContent="center"
            className="img-square-wrapper"
          >
            <img
              alt={props.name}
              src={props.logoUrl}
              style={{
                width: "50px",
                height: "50px",
                objectFit: "contain",
              }}
            />
          </View>

          {/* Title and description */}
          <Col gridGap={"S100"}>
            <Text fontSize="T200" fontWeight="bold" color="neutral90" lineHeight="24px">
              {props?.name}
            </Text>
            {props?.shortDescription && (
              <Text
                data-details-description="details-description"
                fontSize="T200"
                fontWeight="regular"
                color="neutral90"
                lineHeight="24px"
              >
                {props?.shortDescription}
              </Text>
            )}
          </Col>
        </Row>
      </View>
    </a>
  );
};
